import { z } from 'zod'

export type PhoneScheme = z.infer<typeof phoneScheme>

export const phoneScheme = z.object({
  phonePrefix: z
    .string({ required_error: 'Vyberte predvoľbu' })
    .refine((val) => ['+421', '+420'].includes(val), {
      message: 'Neplatná predvoľba',
    }),
  phoneNumber: z
    .string({ required_error: 'Zadajte telefónne číslo' })
    .min(1, { message: 'Telefónne číslo je povinné' })
    .transform((val) => val.replace(/\s+/g, '')) // odstráni medzery
    .refine(
      (val) => {
        const basicFormat = /^[0-9]{9}$/.test(val)
        const extendedFormat = /^[0-9]{9}#[0-9]{1,3}$/.test(val)

        return basicFormat || extendedFormat
      },
      {
        message:
          'Telefónne číslo musí obsahovať presne 9 číslic alebo 9 číslic + # + max 3 číslice',
      }
    )
    .refine((val) => /^[6-9]/.test(val), {
      message: 'Neplatné telefónne číslo – musí začínať číslom 6–9',
    }),
})
